import { RouteConfig } from 'vue-router'
import { marketplaceRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

const MarketplaceFrame = () =>
  import(
    /* webpackChunkName: "calendar-v2" */ '@/pmd/pages/agency/MarketplaceFrame.vue'
  )

export const marketplace: RouteConfig[] = [
  {
    path: '/marketplace',
    component: MarketplaceFrame,
    name: marketplaceRoutes.default,
    beforeEnter: requireAuth,
  },
]
